namespace RedBullMOBILE360.PushNotifications {
    export interface MessageExcelFile extends Serenity.ServiceRequest {
        SendNow?: boolean;
        SendDate?: string;
        FileName?: string;
    }
}
